module.exports = __webpack_public_path__ + "static/img/homebanner1.23990e3a.jpg";